export default __webpack_public_path__ + "static/media/solana.296ec56a.svg";